export const createToggleCopyActionType = (actionPrefix) => `${actionPrefix}/TOGGLE_COPY`;

export const createToggleCopyAction = (actionPrefix) => ({
    type: createToggleCopyActionType(actionPrefix),
});
